// import { useAsyncStorage } from '@react-native-community/async-storage';
import React, { useMemo } from 'react';

import useLocalStorage from '../hooks/useLocalStorage';

type OrganizationContextProps = {
  setOrganization: (...args: any[]) => any;
  organization: any
}

const OrganizationContext = React.createContext<OrganizationContextProps | undefined>(undefined);

type Props = {
	children: React.ReactNode | React.ReactNode[];
};

function OrganizationProvider({ children }: Props) {
	const [organization, setOrganization] = useLocalStorage('organization', null);

	const defaultValue = useMemo(
		() => ({
			organization,
			setOrganization,
		}),
		[organization, setOrganization]
	);
	return (
		<OrganizationContext.Provider value={defaultValue}>{children}</OrganizationContext.Provider>
	);
}

function useOrganization() {
	const context = React.useContext(OrganizationContext);
	if (context === undefined) {
		throw new Error(`useOrganization must be used within a OrganizationProvider`);
	}
	return context;
}

export { OrganizationProvider, useOrganization };
